export const PO_PAYMENT_TERM_STANDARD = 'Standard';
export const PO_PAYMENT_TERM_MILESTONE = 'MilestoneBased';

export const PO_PAYMENT_TERM_TYPE_OPTIONS = [
  { value: PO_PAYMENT_TERM_STANDARD, label: 'Standard' },
  { value: PO_PAYMENT_TERM_MILESTONE, label: 'Milestone-based' },
] as const;

export const PO_MILESTONE_TYPES = [
  'Advance',
  'Material Delivery',
  'Equipment Delivery',
  'Spare Parts Delivery',
  'Consumables Delivery',
  'Service Completion',
  'Subcontract Progress',
  'Installation',
  'Inspection Acceptance',
  'Testing',
  'Commissioning',
  'Final Acceptance',
  'Retention Release',
  'Other',
] as const;

export const PO_MILESTONE_FULFILLMENT_LABELS: Record<string, string> = {
  SupplierAdvance: 'Supplier Advance',
  GRN: 'Goods Receipt (GRN)',
  ServiceReceipt: 'Service Receipt',
  ManualApproval: 'Manual Approval',
};

export const PO_MILESTONE_STATUS_COLORS: Record<string, string> = {
  Pending: 'default',
  Due: 'orange',
  Completed: 'blue',
  Accepted: 'green',
  Rejected: 'red',
  'Partially Received': 'cyan',
  'Fully Received': 'green',
  'Partially Invoiced': 'gold',
  'Fully Invoiced': 'purple',
  Paid: 'green',
  Closed: 'default',
};
